module.exports = __webpack_public_path__ + "img/ex.9878cae8.jpg";